import styled from "styled-components";
function getPaddingLeft({ isIconRight, fontSize }) {
    return !isIconRight
        ? fontSize === "p1"
            ? "padding-left: 3rem;"
            : "padding-left: 2.5rem;"
        : "";
}
export const Placeholder = styled.div `
  height: ${({ height }) => `${height}px`};
  width: 100%;
`;
export const StyledAccordionBody = styled.div `
  width: 100%;
  padding: 0rem 0.5rem 0rem 0.5rem;
  box-sizing: border-box;
  overflow-wrap: break-word;
  overflow: hidden;

  ${getPaddingLeft};

  font-size: ${({ theme, fontSize }) => fontSize === "p1"
    ? theme.fontTokens.font11[0]
    : theme.fontTokens.font12[0]};
  line-height: ${({ theme, fontSize }) => fontSize === "p1"
    ? theme.fontTokens.font11[1]
    : theme.fontTokens.font12[1]};

  @media ${({ theme }) => theme.device.touch} {
    ${({ isIconRight }) => (!isIconRight ? "padding-left: 2.75rem;" : "")};
  }
`;
export const StyledWrapper = styled.div `
  position: relative;
  display: grid;
  grid-template-rows: 0fr;
  transition-property: grid-template-rows;
  transition-timing-function: ease-out;
  transition-duration: 300ms;

  ${({ opened }) => opened
    ? `
      grid-template-rows: 1fr;
      transition-timing-function: ease-in;
          `
    : ""};

  ${StyledAccordionBody} {
    min-height: unset;
  }
`;
